// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;


//#endregion
import React, { useEffect } from 'react';
import AppRoutes from './routes';
import { AuthProvider } from './context/AuthContext';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  // 监听登录状态变化
  useEffect(() => {
    // 监听登出事件
    const handleLogout = (event) => {
      toast.info(event.detail || '登录已过期，请重新登录');
      // 也可以在这里执行其他操作，例如重定向到登录页面
    };

    // 监听登录事件
    const handleLogin = (event) => {
      toast.success(event.detail || '登录成功');
    };

    // 添加事件监听器
    window.addEventListener('auth:logout', handleLogout);
    window.addEventListener('auth:login', handleLogin);

    // 清理事件监听器
    return () => {
      window.removeEventListener('auth:logout', handleLogout);
      window.removeEventListener('auth:login', handleLogin);
    };
  }, []);

  return (
    <div className="App">
      <ToastContainer position="top-center" autoClose={3000} />
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </div>
  );
}

export default App;


